// extracted by mini-css-extract-plugin
export default {"root":"pObuu","logo":"AKYGM"};